var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"container footer mt-auto py-3"},[_c('div',{staticClass:"footer-company"},[_c('p',[_vm._v("2023 © All Rights Reserved by SMBE Shanghai 2023")]),_c('p',[_c('a',{attrs:{"href":"#/home"}},[_vm._v("Home")]),_c('a',{attrs:{"href":"#/submission"}},[_vm._v("Submission")]),_c('a',{attrs:{"href":"#/about"}},[_vm._v("About")])])])])
}]

export { render, staticRenderFns }